module.exports = __webpack_public_path__ + "img/Künstlerin.2136a819.svg";